"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanApplyRequest = void 0;
var LoanApplyRequest = /** @class */ (function () {
    function LoanApplyRequest() {
        this.applyAmount = ''; // 申请金额
        this.applyTerm = ''; // 申请期限
        this.termType = ''; // 期限类型
        this.rateType = ''; // 利率类型
        this.quotaRate = ''; // 利率
        this.applyUse = ''; // 借款用途
        this.custName = ''; // 借款人姓名
        this.payWay = ''; // 还款方式编码
    }
    return LoanApplyRequest;
}());
exports.LoanApplyRequest = LoanApplyRequest;
;
//# sourceMappingURL=loanApply.request.js.map